import React, { useState } from "react"
import types from "prop-types"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import { SUBMITTER_ROLE } from "utils/userRoleHelpers"
import { UserRoleSelect } from "shared/selects"
import ItemRow from "shared/ItemRow"
import * as API from "services/api"
import { errorToast } from "shared/toast"

const USER_UPDATE_ERROR_MESSAGE = "Unable to change role"
const confirmationPrompt = (fullName, departmentsInSentence) => `Are you sure you'd like to make ${fullName} a submitter?`
  + "\n\n"
  + `${fullName} will lose all access to Activity Hub, and `
  + `be removed from all groups, ${departmentsInSentence}, workflows, and tasks.`

const confirmRoleChange = (fullName, departmentsInSentence) => (
  window.confirm(confirmationPrompt(fullName, departmentsInSentence))
)

const UserRole = ({ user, updateRole }) => {
  const { pluralNameInSentence: departmentsInSentence } = useCustomName(DEPARTMENT_KEY)

  // resets select to most recent valid state
  const [pristineKey, setPristineKey] = useState(Date.now())

  const updateUserRole = async (role) => {
    if (user.role === role) return

    if (role === SUBMITTER_ROLE && !confirmRoleChange(user.fullName, departmentsInSentence)) {
      setPristineKey(Date.now())
      return
    }

    const response = await API.updateUserRole({ userId: user.id, role })

    if (response.ok) {
      updateRole(role)
    } else {
      setPristineKey(Date.now())
      const errorsString = response.data.errors.join(", ")
      errorToast(`${USER_UPDATE_ERROR_MESSAGE}: ${errorsString}`)
    }
  }

  return (
    <ItemRow
      className="dark"
      itemRowHeaderContent={(
        <>
          <span className="font-bold">Role</span>
          <UserRoleSelect
            key={pristineKey}
            placeholder="Role"
            value={user.role}
            onChange={updateUserRole}
            label={`select role for ${user.first_name} ${user.last_name}`}
            style={{ backgroundColor: "white" }}
          />
        </>
      )}
      itemRowBody={(
        <p>Is this user an admin or not?</p>
      )}
    />
  )
}

UserRole.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  user: types.object.isRequired,
  updateRole: types.func.isRequired,
}

export default UserRole
